import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEarth: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconEarth"><Path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.8337 17L17 14.564L13.5616 12.151L11.2954 12L10.002 13.3459L12.3346 17H15.8337ZM9.00622 9.00495L8.00122 10.9999L4.77246 8.56502C6.05773 5.86568 8.81076 4 11.9995 4C12.6704 4 13.3219 4.08256 13.9445 4.23808L13.0012 7.99995L9.00622 9.00495Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEarth;
